import {Schema} from 'prosemirror-model'

import styles from './nodes.module.css'

// Note our schema doesn't support any phrasing content, only flow content (blocks). Phrasing content is
// represented by decorations since the user edits those Markdown delimiters directly in the editor
export const schema = new Schema({
  nodes: {
    // required: root document node
    doc: {
      content: 'flow*', // borrowing the 'flow' terminology from mdast
    },
    paragraph: {
      group: 'flow',
      content: 'text*',
      toDOM() {
        // Node-level decorators are only able to wrap, not replace, node elements. So if we render `p` here, we'd end
        // up with an `h* > p` structure when we go to decorate this node with a heading tag. That's invalid, so instead
        // we render a semantically inert element here and wrap everything that isn't a heading in a `p` tag using
        // decorations. The result is `h* > span` or `p > span`, both of which are valid HTML.
        return ['span', 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: 'p',
        },
      ],
    },
    blockquote: {
      group: 'flow',
      content: 'flow+',
      toDOM() {
        return ['blockquote', 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: 'blockquote',
        },
      ],
    },
    thematicBreak: {
      // borrowing from mdast terminology
      group: 'flow',
      toDOM() {
        return ['hr']
      },
      inline: false,
      parseDOM: [
        {
          tag: 'hr',
        },
      ],
    },
    unsupported: {
      group: 'flow',
      content: 'text*',
      toDOM() {
        return ['div', {class: styles.unsupported}, 0]
      },
      inline: false,
      parseDOM: [
        {
          tag: `div.${styles.unsupported}`,
        },
      ],
      attrs: {},
    },
    text: {
      inline: true,
    },
  },
})
